import * as React from 'react';
import { SVGProps } from 'react';

const IconCollapseSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 1H6v5H1v2h3v3h2V6h5V4H8V1z" />
  </svg>
);
export default IconCollapseSizeXs;
